import { useEffect } from 'react';
import { ErrorComponentProps, useRouter } from '@tanstack/react-router';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import LoadError from '@/components/ui/LoadError.tsx';

/**
 * `errorComponent` ekranów zmian — renderuje się wewnątrz layoutu aplikacji,
 * więc menu zostaje. Globalna `AppErrorPage` zmiata całe chrome, co jest za
 * dużym młotem na nieudany rachunek jednej rezerwacji.
 */
const DetailsErrorPage = ({ error }: ErrorComponentProps) => {
  // Bez tego operator widzi sam komunikat, a w konsoli nie ma po czym szukać.
  useEffect(() => {
    console.error('[DetailsErrorPage]', error);
  }, [error]);

  const router = useRouter();

  return (
    <div className="p-8">
      <LoadError subject="tego ekranu">
        {/* `invalidate` puszcza loader od nowa; samo zresetowanie granicy
            błędu pokazałoby ten sam błąd, bo dane nadal by nie doszły. */}
        <ActionButton tone="accent" onClick={() => void router.invalidate()}>
          Spróbuj ponownie
        </ActionButton>
      </LoadError>
    </div>
  );
};

export default DetailsErrorPage;
